export default "__VITE_ASSET__8EE1FW5q__"